const topics = [
  { id: 1, name: '明星恋情', count: '128.6万', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-600 border-primary-200' },
  { id: 2, name: '综艺争议', count: '96.3万', icon: 'ri-tv-line', color: 'bg-accent-100 text-accent-600 border-accent-200' },
  { id: 3, name: '网红翻车', count: '87.1万', icon: 'ri-alert-line', color: 'bg-secondary-100 text-secondary-600 border-secondary-200' },
  { id: 4, name: '影视动态', count: '72.5万', icon: 'ri-film-line', color: 'bg-primary-100 text-primary-600 border-primary-200' },
  { id: 5, name: '饭圈大战', count: '65.8万', icon: 'ri-fire-line', color: 'bg-accent-100 text-accent-600 border-accent-200' },
  { id: 6, name: '时尚红毯', count: '58.2万', icon: 'ri-shirt-line', color: 'bg-secondary-100 text-secondary-600 border-secondary-200' },
  { id: 7, name: '音乐八卦', count: '51.4万', icon: 'ri-music-line', color: 'bg-primary-100 text-primary-600 border-primary-200' },
  { id: 8, name: '直播带货', count: '46.9万', icon: 'ri-shopping-bag-line', color: 'bg-accent-100 text-accent-600 border-accent-200' },
  { id: 9, name: '行业爆料', count: '42.3万', icon: 'ri-megaphone-line', color: 'bg-secondary-100 text-secondary-600 border-secondary-200' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium mb-3">
            <i className="ri-hashtag"></i>
            话题广场
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            热门话题
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            按话题分类浏览，快速找到你最关心的娱乐圈动态
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 max-w-5xl mx-auto">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#"
              className={`group rounded-2xl border p-5 cursor-pointer hover:shadow-sm transition-all duration-300 ${topic.color}`}
            >
              <div className="flex items-center gap-2 mb-3">
                <i className={`${topic.icon} text-lg`}></i>
                <span className="font-heading font-bold text-sm">{topic.name}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-xs opacity-70">{topic.count} 讨论</span>
                <span className="text-xs opacity-0 group-hover:opacity-70 transition-opacity flex items-center gap-0.5">
                  进入 <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}